<div class="container-fluid">
    <div class="row">
      <div
        class="col-12 col-sm-5 d-none d-sm-flex flex-column min-full-height justify-content-between left-panel position-relative"
      >
        <img
          src="../../../assets/images/Logo-colorido.png"
          alt="Logo"
          class="logo"
        />
        <p class="bottom-text">
          Avoid The Headache, Get a Simple Solution That Meets Your Needs
        </p>
      </div>
      <div class="col-12 d-sm-none pt-5 px-4">
        <img
          src="../../../assets/images/Logo-colorido.png"
          alt="Logo"
          class="logo"
        />
      </div>
      <div class="col-12 col-sm-7">
        <div class="right-panel">
          <form class="login-form">
            <p class="title">Security Verification</p>
            <div class="form-group">
              <label>To secure your login, please enter the 6-digit code that we have sent to your phone ••• ••• {{lastDigitsPhone}}</label>
            </div>
            <div class="form-group">
              <div class="otp-inputs">
                <input
                type="text"
                maxlength="1"
                id="otpField0"
                name="otpField0"
                (input)="onInputChange(otpInputs[0], 0)"
                [(ngModel)]="otpInputs[0]"
                (keypress)="handleKeypress($event)"
                [ngClass]="{ 'active': currentInput === 0 }"
              />
                <input
                  type="text"
                  maxlength="1"
                  id="otpField1"
                  name="otpField1"
                  (input)="onInputChange(otpInputs[1], 1)"
                  [(ngModel)]="otpInputs[1]"
                  (keydown)="handleKeydown($event, 1)"
                  [ngClass]="{ 'active': currentInput === 1 }"
                />
                <!-- Repite este bloque para los campos 2, 3, 4 y 5 -->
                <!-- Campo 2 -->
                <input
                  type="text"
                  maxlength="1"
                  id="otpField2"
                  name="otpField2"
                  (input)="onInputChange(otpInputs[2], 2)"
                  [(ngModel)]="otpInputs[2]"
                  (keydown)="handleKeydown($event, 2)"
                  [ngClass]="{ 'active': currentInput === 2 }"
                />
                <!-- Campo 3 -->
                <input
                  type="text"
                  maxlength="1"
                  id="otpField3"
                  name="otpField3"
                  (input)="onInputChange(otpInputs[3], 3)"
                  [(ngModel)]="otpInputs[3]"
                  (keydown)="handleKeydown($event, 3)"
                  [ngClass]="{ 'active': currentInput === 3 }"
                />
                <!-- Campo 4 -->
                <input
                  type="text"
                  maxlength="1"
                  id="otpField4"
                  name="otpField4"
                  (input)="onInputChange(otpInputs[4], 4)"
                  [(ngModel)]="otpInputs[4]"
                  (keydown)="handleKeydown($event, 4)"
                  [ngClass]="{ 'active': currentInput === 4 }"
                />
                <!-- Campo 5 -->
                <input
                  type="text"
                  maxlength="1"
                  id="otpField5"
                  name="otpField5"
                  (input)="onInputChange(otpInputs[5], 5)"
                  [(ngModel)]="otpInputs[5]"
                  (keydown)="handleKeydown($event, 5)"
                  [ngClass]="{ 'active': currentInput === 5 }"
                />
              </div>
              <div *ngIf="contador > 0; else resendCodeBlock">
                <label class="input-label">You can request a new code or choose another way to receive it in {{ contador }}</label>
              </div>
              <ng-template #resendCodeBlock>
                <label *ngIf="mostrarMensaje" class="input-label">
                  Didn't get a code? <a class="resend-code" (click)="reiniciarContador()">Resend code</a>
                </label>
                <label *ngIf="mostrarMensajeCorreo" class="input-label">
                  You did not receive the code?, <a class="resend-code" (click)="enviarCorreoConCodigo()"> Send me an email with the code</a>
                </label>
                <label *ngIf="mostrarMensajeCorreoFinal" class="input-label">
                  You did not receive the code, inform the system administrator.
                </label>
              </ng-template>
            </div>
            <div class="row">
              <div class="col">
                <button (click)="obtenerCodigo()"
                type="submit"
                class="sign-in-button btn btn-primary"
                [disabled]="!fieldsCompleted"
    
                >Continue</button>

              </div>
            </div>
            <div class="row">
              <div class="col">
                  <button class="cancel-button btn btn-secondary" (click)="goToLogin()">Cancel</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  